import { Component, OnInit, ViewChild, ElementRef, Input, OnChanges, SimpleChanges, Output, ViewEncapsulation, EventEmitter, AfterViewInit, Renderer2, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ViewportService } from 'src/app/services/viewport.service';
import { DialogModule } from 'primeng/dialog';
import { SkeletonModule } from 'primeng/skeleton';
import { DraggableDirective } from 'src/app/shared/directives/draggable.directive';
import { ViewportRuler } from '@angular/cdk/overlay';
import { Item } from 'src/app/models/liveshop';
import { VideoModalService } from 'src/app/services/video-modal.service';
import { Subscription } from 'rxjs';
import { FakePagePreviewComponent } from 'src/app/components/fake-page-preview/fake-page-preview.component';

export interface VideoItem {
  uid: string;
  id: number;
  src: string;   // URL do vídeo
  poster: string; // Poster do vídeo
  thumbnail?: string;
}
@Component({
  selector: 'app-popup',
  standalone: true,
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss'],
  imports: [CommonModule, ConfirmDialogModule, DialogModule, SkeletonModule, DraggableDirective, FakePagePreviewComponent],
  encapsulation: ViewEncapsulation.Emulated
})
export class PopupComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  @Input() arraySlicksFull: Item[] = [];
  @Input() position: 'center' | 'top' | 'bottom' | 'left' | 'right' | 'topleft' | 'topright' | 'bottomleft' | 'bottomright' = 'center';
  @Input() highlight?: string;
  @Input() shape?: string;
  @Input() isAdmin: boolean = false;
  @Input() height?: number | undefined;
  @Input() backgroundColor?: string;
  @Input() font_color: string = "#000000";
  @Input() widget_id?: number | undefined;
  @Input() templateType: string | undefined;
  @Input() pageToVideos: number = 0;
  @Input() disableClicks: boolean = false;
  @Input() adminModeActive: boolean = false;
  visible: boolean = true;
  selectedVideoUrl: VideoItem | undefined;
  @Input() videoUrls: VideoItem[] = [];
  @ViewChild('dialogContainer', { read: ElementRef }) dialogContainer!: ElementRef;
  @ViewChild('videoPlayer') videoPlayer!: ElementRef<HTMLVideoElement>;
  @Input() totalAssets: number = 0;
  @Input() instanceId?: string;
  @Input() store_id?: number;
  private isDragging = false;
  private offsetX = 0;
  private offsetY = 0;
  @ViewChild('highlightElement') highlightElement!: ElementRef;
  @ViewChild('draggablePopupEl') draggablePopupEl?: ElementRef<HTMLDivElement>;
  private modalStateSub?: Subscription;
  private previewFrameResizeObserver?: ResizeObserver;
  private previewFrameCleanup?: () => void;
  private previewFrameEl?: HTMLElement;

  constructor(
    private viewportService: ViewportService,
    private viewportRuler: ViewportRuler,
    private renderer: Renderer2,
    private host: ElementRef,
    private videoModalService: VideoModalService,
    private cdr: ChangeDetectorRef
  ) {

  }
  ngAfterViewInit(): void {
    if (this.videoPlayer && this.videoPlayer.nativeElement) {
      this.videoPlayer.nativeElement.muted = true;
    }
    this.viewportService.setTemplateType(this.templateType);
    this.startFadeOutTimer();

    // Prévia admin: o popup arrastável nasce dentro de .ss-l-fake-page-wrapper,
    // que é o conteúdo que ROLA (.ss-l-preview-scroll, mais externo). Reparentamos
    // ele pra fora do scroll — igual o PrimeNG faz com appendTo="body" em
    // dialog/tooltip — pra ele ficar preso na área visível da prévia independente
    // do scroll da página fake. Mas .ss-l-preview-area (o destino) é mais larga
    // que o card fake de verdade (ela centraliza o card por dentro, com padding),
    // então criamos um "quadro" invisível do tamanho exato de .ss-l-preview-scroll
    // (a área visível real, que não se move com o scroll interno) e colocamos o
    // popup dentro dele — isso confina a posição inicial E o arrasto (via
    // confineToBoundary/offsetParent) exatamente aos limites do card visível.
    if (this.isAdmin && this.draggablePopupEl) {
      const el = this.draggablePopupEl.nativeElement;
      const previewArea = el.closest('.ss-l-preview-area') as HTMLElement | null;
      const scrollArea = el.closest('.ss-l-preview-scroll') as HTMLElement | null;

      if (previewArea && scrollArea) {
        const frame = this.renderer.createElement('div') as HTMLElement;
        this.renderer.setStyle(frame, 'position', 'absolute');
        this.renderer.setStyle(frame, 'pointer-events', 'none');
        this.renderer.appendChild(previewArea, frame);
        this.renderer.appendChild(frame, el);
        // pointer-events é herdado — sem isso o popup herda "none" do quadro e
        // para de receber clique/arrasto.
        this.renderer.setStyle(el, 'pointer-events', 'auto');
        this.previewFrameEl = frame;

        const updateFrame = () => {
          const pRect = previewArea.getBoundingClientRect();
          const sRect = scrollArea.getBoundingClientRect();
          this.renderer.setStyle(frame, 'left', `${sRect.left - pRect.left}px`);
          this.renderer.setStyle(frame, 'top', `${sRect.top - pRect.top}px`);
          this.renderer.setStyle(frame, 'width', `${sRect.width}px`);
          this.renderer.setStyle(frame, 'height', `${sRect.height}px`);
        };
        updateFrame();

        this.previewFrameResizeObserver = new ResizeObserver(updateFrame);
        this.previewFrameResizeObserver.observe(scrollArea);
        this.previewFrameResizeObserver.observe(previewArea);
        window.addEventListener('resize', updateFrame);
        this.previewFrameCleanup = () => {
          window.removeEventListener('resize', updateFrame);
          this.previewFrameResizeObserver?.disconnect();
        };
      } else if (previewArea) {
        this.renderer.appendChild(previewArea, el);
      }
    }
  }
  fadeOutTimer: any;
  startFadeOutTimer() {
    clearTimeout(this.fadeOutTimer);
    this.fadeOutTimer = setTimeout(() => {
      if (this.highlightElement?.nativeElement) {
        this.renderer.addClass(this.highlightElement.nativeElement, 'fadeout');
      }
    }, 7000);
  }

  onDialogMouseEnter() {
    if (this.highlight && this.highlight.length > 0 && this.highlightElement?.nativeElement) {
      this.renderer.removeClass(this.highlightElement.nativeElement, 'fadeout');
      this.renderer.addClass(this.highlightElement.nativeElement, 'fadein');
    }
  }

  onDialogMouseLeave() {
    if (this.highlight && this.highlight.length > 0 && this.highlightElement?.nativeElement) {
      this.renderer.removeClass(this.highlightElement.nativeElement, 'fadein');
    }
    this.startFadeOutTimer();
  }
  // Método chamado quando o diálogo é exibido
  onDialogShow(): void {
    this.startFadeOutTimer();
    // Tenta acessar o `.p-dialog-content` diretamente no documento
    const dialogContentElement = document.querySelector('.p-dialog-content');
    if (dialogContentElement) {
      // eslint-disable-next-line @angular-eslint/no-input-rename
      this.renderer.setStyle(dialogContentElement, 'background-color', 'transparent');
      //  	  2this.renderer.setStyle(dialogContentElement, 'transform', 'translate("100px", 0)');
    } else {
      console.warn('Elemento `.p-dialog-content` não encontrado');
    }
  }

  @Output() openSidebar = new EventEmitter<void>();

  ngOnInit(): void {
    this.modalStateSub = this.videoModalService.state$.subscribe((state) => {
      if (state.instanceId && this.instanceId && state.instanceId !== this.instanceId) {
        return;
      }
      if (!state.show && !this.visible) {
        this.visible = true;
        this.cdr.detectChanges();
      }
    });
    /////////////////////////////////////////

    //this.startFadeOutTimer();
  }

  private wasDragged = false;

  onDragEnd() {
    this.wasDragged = true; // Seta a flag de arrasto
  }


  private touchStartTime: number = 0;
  private touchMoved = false;
  private touchStartX: number = 0;
  private touchStartY: number = 0;
  handleTouchStart(event: TouchEvent) {
    this.touchStartTime = Date.now();
    this.touchMoved = false;
    this.wasDragged = false;

    // 🔹 Salva coordenadas iniciais do toque
    const touch = event.touches[0];
    this.touchStartX = touch.clientX;
    this.touchStartY = touch.clientY;
  }

  handleTouchMove(event: TouchEvent) {
    this.touchMoved = true; // Se mover o dedo, consideramos que não é tap
  }

  handleTouchEnd(event: TouchEvent) {
    const touchDuration = Date.now() - this.touchStartTime;
  
    const touch = event.changedTouches[0];
    const deltaX = Math.abs(touch.clientX - this.touchStartX);
    const deltaY = Math.abs(touch.clientY - this.touchStartY);
    const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
  
    // 🔸 Se moveu mais que 10px, consideramos arrasto
    if (distance > 10) {
      return;
    }
  
    // ✅ Toque válido
    if (touchDuration < 300) {
      this.handleClick();
    }
  
    this.touchMoved = false;
    this.touchStartTime = 0;
  }
  


  private mouseDown = false;
  private mouseMoved = false;

  handleMouseDown(event: MouseEvent) {
    this.mouseDown = true;
    this.mouseMoved = false;
    this.wasDragged = false;
  }

  handleMouseMove(event: MouseEvent) {
    if (this.mouseDown) {
      this.mouseMoved = true;
    }
  }

  handleMouseUp(event: MouseEvent) {
    this.mouseDown = false;

    if (this.wasDragged) {
      this.wasDragged = false;
      return; // ⛔ não deve disparar clique
    }

    if (!this.mouseMoved) {
      this.handleClick();
    }

    this.mouseMoved = false;
  }

  handleClick() {
    this.openModal();
  }

  openModal() {
    if (!this.videoUrls?.length) {
      return;
    }

    const video = this.videoUrls[0];
    this.visible = false;

    void this.videoModalService.open({
      video,
      slicks: this.arraySlicksFull,
      totalAssets: this.totalAssets,
      isAdmin: this.isAdmin,
      widgetId: this.widget_id,
      height: this.height,
      pageToVideos: this.pageToVideos,
      instanceId: this.instanceId,
      storeId: this.store_id
    });

    this.cdr.detectChanges();
  }
  resetPosition: boolean = false;
  showHighlight: boolean = false;
  ngOnChanges(changes: SimpleChanges): void {
    this.visible = true;
    if (changes['videoUrls'] && this.videoUrls.length > 0) {


      this.selectedVideoUrl = this.videoUrls[0]; // Pegando apenas o primeiro vídeo
      // Forçar recarregamento do vídeo
      if (this.videoPlayer) {
        const videoElement = this.videoPlayer.nativeElement;
        videoElement.load(); // Recarrega o vídeo quando a URL é alterada
      }

    }
    if (changes['position']) {
      this.resetPosition = true;
      setTimeout(() => {
        this.resetPosition = false;
      }, 0);
    }
    if (changes['height']) {
    }
    if (changes['font_color']) {
    }
    if (changes['highlight']) {
    }
    if (changes['shape']) {
    }
    if (changes['backgroundColor']) {
    }
  }

  getDialogClass(): string {
    switch (this.shape) {
      case 'portrait':
        return 'dialog-portrait';
      case 'landscape':
        return 'dialog-landscape';
      case 'circle':
        return 'dialog-circle';
      default:
        return 'dialog-circle';
    }
  }
  getDialogStyle() {
    return {
      'background-color': this.backgroundColor ? this.backgroundColor : 'inherit'
    };
  }
  loading: boolean = true;
  onVideoLoaded(): void {
    this.loading = false; // Desativar o skeleton quando o vídeo for carregado
    this.showHighlight = true;
    // Garante que o vídeo está mutado quando os metadados carregam
    if (this.videoPlayer && this.videoPlayer.nativeElement) {
      this.videoPlayer.nativeElement.muted = true;
    }
  }
  onOpenSidebar(): void {
    this.openSidebar.emit();
  }

  ngOnDestroy(): void {
    this.modalStateSub?.unsubscribe();
    this.previewFrameCleanup?.();
    // O Angular destrói a view de app-popup esperando encontrar seus nós no
    // lugar original — como o reparentamos pra .ss-l-preview-area (fora da
    // árvore que o Angular rastreia), sem isso ele fica órfão na tela pra
    // sempre quando o template muda (o *ngSwitchCase troca de componente mas
    // o nó movido não é removido automaticamente).
    this.previewFrameEl?.remove();
  }
}
